import React, { useState, ChangeEvent, KeyboardEvent, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { SearchQuery } from '../../../services/types/Search';

const SearchBar: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [queryFilter, setQueryFilter] = useState({ query: '' } as SearchQuery);

  const handleSearch = () => {
    if (queryFilter.query.length < 3) {
      return;
    }
    if (location.pathname.indexOf('/results') > -1) {
      navigate(`/results/${queryFilter.query}`, { replace: true });
      navigate(0);
    } else {
      navigate(`/results/${queryFilter.query}`);
    }
  };

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQueryFilter({ query: e.target.value });
  };

  const handleOnKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleOnClick = (e: MouseEvent) => {
    e.preventDefault();
    handleSearch();
  };

  return (
    <div className="topbar__search">
      <div className="searchbar">
        <form className="form">
          <div className="form-row">
            <div className="col-sm-12 searchbar__input-wrapper">
              <input
                type="text"
                name="search"
                placeholder={t('search')}
                onChange={handleOnChange}
                onKeyPress={handleOnKeyPress}
              />
              <div className="searchbar__input-icon">
                <span onClick={handleOnClick} role="button" tabIndex={0}>
                  <FontAwesomeIcon icon={faSearch} />
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default React.memo(SearchBar);
